export default {
  title: {
    id: 'myprofile_infos_modal_title',
    defaultMessage: 'Personal Information',
  },
  updatePasswordSuccess: {
    id: 'myprofile_notification_success_password',
    defaultMessage: 'Your password has been updated successfully.',
  },
  error: {
    id: 'myprofile_notification_error',
    defaultMessage:
      'Oops! An error occurred and we were unable to fulfill your request. Please try again later.',
  },
  confirmNewPassword: {
    id: 'confirm_new_password',
    defaultMessage: 'Confirm password',
  },
  currentPassword: {
    id: 'old_password',
    defaultMessage: 'Current password',
  },
  newPassword: {
    id: 'new_password',
    defaultMessage: 'New password',
  },
  passwordNewRequired: {
    id: 'input_password_new_required',
    defaultMessage: 'The password field is required',
  },
  passwordCurrentRequired: {
    id: 'input_password_current_required',
    defaultMessage: 'The password field is required',
  },
  passwordNewSameAsCurrent: {
    id: 'myprofile_password_new_same_as_current',
    defaultMessage: "The new password can't be the same as the current one",
  },
  passwordMismatch: {
    id: 'myprofile_password_validation_failed',
    defaultMessage: "These passwords don't match",
  },
  passwordRules: {
    id: 'myprofile_infos_modify_password_rules',
    defaultMessage:
      'At least 8 characters, including 1 uppercase letter, 1 lowercase letter and 1 digit. Because you never know.',
  },
  passwordButtonHideAriaLabel: {
    id: 'input_password_current_button_hide_label',
    defaultMessage: 'Hide password',
  },
  passwordButtonShowAriaLabel: {
    id: 'input_password_current_button_show_aria_label',
    defaultMessage: 'Reveal password',
  },
  save: {
    id: 'myprofile_button_save',
    defaultMessage: 'Save',
  },
  requiredField: {
    id: 'form_rules_required',
    defaultMessage: 'This field is required',
  },
  invalidPassword: {
    id: 'input_password_wrong_format',
    defaultMessage: 'Insert a valid password',
  },
  passwordStrength: {
    id: 'input_password_password_too_weak_error',
    defaultMessage:
      'The password must have at least 8 characters, 1 uppercase letter, 1 lowercase letter and 1 digit.',
  },
  passwordTooSimilar: {
    id: 'input_password_password_too_similar_error',
    defaultMessage:
      "Your password can't be too similar to your other personal information.",
  },
  passwordTooCommon: {
    id: 'input_password_password_too_common_error',
    defaultMessage: "Your password can't be a commonly used password.",
  },
  passwordTooLong: {
    id: 'input_password_password_too_long_error',
    defaultMessage: 'Enter a password less than 64 characters.',
  },
  passwordReuse: {
    id: 'input_password_password_reuse_error',
    defaultMessage: 'This is an old password. Please create a new one.',
  },
  passwordOldWrong: {
    id: 'input_password_wrong_old_password',
    defaultMessage: 'Incorrect old password',
  },
}
